import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import analytics from '../utils/analytics';
import { trackPageView } from '../utils/appInsights';

// Functional component that listens for route changes and sends page_view events
export default function RouteTracker() {
  const location = useLocation();
  const prevPath = useRef(null);

  useEffect(() => {
    const currentPath = location.pathname + location.search;

    // Send to App Insights – includes the previous page so navigation flow
    // (e.g. Shop → Product → Cart) is visible in the traces.
    trackPageView(currentPath, prevPath.current);

    // Send to GA4 (consent-gated)
    analytics.sendPageView(currentPath);

    prevPath.current = currentPath;
  }, [location]);

  return null;
}
